export default __webpack_public_path__ + "fonts/museo-slab-500.woff2";